module.exports = __webpack_public_path__ + "static/media/gurubashi.2b4c13ce.gif";